import Repository from "@/api/repository";
import { baseUrl } from "./base";
export default {
    getUserAccessToExperiment(experimentId) {
        return Repository.get(`${baseUrl}/experiment/${experimentId}`);
    }
};
